import React from 'react';
import createReactClass from 'create-react-class';
import Widget from '../common/Widget';
import moment from 'moment';
import { Link } from 'react-router-dom';
import request from '../../helpers/request';
import dashboardConfig from './config/dashboardConfig';

var TodoWidget = createReactClass({
  getDefaultProps(){
    return {
    };
  },

  getInitialState() {
    return {
      todos: []
    };
  },

  componentDidMount() {
    request.get({
      url: dashboardConfig.apiUrl + 'todos',
      success: todos => {
        if (this.isMounted()) {
          this.setState({
            todos: todos
          });
        }
      }
    });
  },

  render() {
    var criticalTodos = this.state.todos
      .filter(x => x.severity === 0)
      .map(this._renderTodo);

    var importantTodos = this.state.todos
      .filter(x => x.severity === 1)
      .map(this._renderTodo);

    return (
      <Widget title="ToDo's" icon="check" containerClassName="col-sm-12 col-md-12 col-lg-6" bodyClassName="smart-form">
        <div className="chat-body custom-scroll">
          <h5 className="todo-group-title"><i className="fa fa-warning"></i> Kritische Aufgaben (<small className="num-of-tasks">{criticalTodos.length}</small>)</h5>
          <ul id="sortable1" className="todo">
              {criticalTodos}
          </ul>
          <h5 className="todo-group-title"><i className="fa fa-exclamation"></i> Wichtige Aufgaben (<small className="num-of-tasks">{importantTodos.length}</small>)</h5>
          <ul id="sortable2" className="todo">
              {importantTodos}
          </ul>
        </div>
      </Widget>
    );
  },

  _renderTodo(todo) {
    let createdString = moment(todo.dateCreated).format('DD.MM.YYYY HH:mm:ss');

    return (
      <li key={todo.id}>
          <span className="handle">
            <Link to={todo.link}>
              <label className="checkbox">
                <input type="checkbox" name="checkbox-inline" disabled />
                <i></i>
              </label>
            </Link>
          </span>
          <p>
            <strong>
              <Link to={todo.link}>{todo.title}</Link>
            </strong>
            <span>{todo.message}</span>
            <span className="date">{createdString}</span>
          </p>
      </li>
    );
  },
});


export default TodoWidget;



// WEBPACK FOOTER //
// ./src/components/dashboard/TodoWidget.js